import './welcome-banner.css';
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthState } from '@vis-auth/react';
import {
  getUserData,
  getUserAgencyData,
  hasUserRole,
  SUPER_USER,
  THIRD_STEP_USER,
  THIRD_STEP_SUPERVISOR,
  SaveModRoutes,
  SaveLegacyRoutes,
  getBasePaths,
  getUserRoleDisplayName,
  isToggleEnabled,
} from '@save/utils';

export default function WelcomeBanner() {
  const authState = useAuthState();
  const userRoles = authState.user.roles;
  const userData = getUserData();
  const userAgencyData = getUserAgencyData();
  const legacyBasePath = getBasePaths(userRoles);
  const showCreateCaseButton =
    (!isToggleEnabled('DISABLE_CREATE_CASE_WITHOUT_TRAINING') || userData.tutorialComplete) &&
    !hasUserRole(userRoles, SUPER_USER) &&
    !hasUserRole(userRoles, THIRD_STEP_USER) &&
    !hasUserRole(userRoles, THIRD_STEP_SUPERVISOR);
  const showSearchCasesButton =
    !hasUserRole(userRoles, THIRD_STEP_USER) && !hasUserRole(userRoles, THIRD_STEP_SUPERVISOR);
  const showThirdStepSearchButton =
    hasUserRole(userRoles, THIRD_STEP_USER) || hasUserRole(userRoles, THIRD_STEP_SUPERVISOR);

  return (
    <div className="welcome-banner width-full">
      <div className="grid-container">
        <div className="grid-row grid-gap-lg flex-justify flex-align-center">
          <div>
            <h1 className="text-white margin-bottom-2">{`Welcome, ${userData?.firstName ?? ''}`}</h1>
            {showCreateCaseButton && (
              <Link
                to={SaveModRoutes.CREATE_CASE}
                aria-label="Navigate to Create New Case"
                className="usa-button usa-button--outline usa-button--inverse ver-button"
              >
                Create New Case
              </Link>
            )}
            {showSearchCasesButton && (
              <Link
                to={SaveModRoutes.SEARCH_CASES}
                aria-label="Navigate to Search Cases"
                className="usa-button usa-button--outline usa-button--inverse ver-button"
              >
                Search Cases
              </Link>
            )}
            {showThirdStepSearchButton && (
              <Link
                to={SaveModRoutes.FIND_CASE}
                aria-label="Navigate to Search Cases"
                className="usa-button usa-button--outline usa-button--inverse ver-button"
              >
                Search Cases
              </Link>
            )}
          </div>
          <div className="text-white text-right" data-testid="agency-details">
            <div data-testid="user-role">
              User Role: {getUserRoleDisplayName(userData?.roles, userData?.verificationResponseCode)}
            </div>
            <div data-testid="user-agency-id">Agency Id: {userAgencyData?.agencyId}</div>
            <div data-testid="user-agency-name">Agency Name: {userAgencyData?.agencyName}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
